import { useQuery } from "@tanstack/react-query";
import { apiQueryAdapter } from "app/data/apiQueryAdapter";
import { QUERY_KEYS } from "app/data/common/queryKeys";

export const useCarrier = () => {

  const { data, isLoading, refetch } =
    useQuery({
      queryKey: [QUERY_KEYS.GET_CARRIER],
      queryFn: async () => {

        const response = await apiQueryAdapter.query<any>(`/carrier/dropdown`,
          "GET"
        );

        return response.data;

      },
      refetchOnWindowFocus: false,
      retry: false,
    })
    
  return { data, isLoading, refetch };
}